import './GroupSettings.scss'
import { postNewInvite } from '../../APICalls/GetRequests'
import { fetchGroupInvites } from '../../APICalls/GetRequests';
import { fetchAssociatedUsers } from '../../APICalls/GetRequests';
import { changeUserRole } from '../../APICalls/PutRequests';
import Cookies from 'js-cookie';
import { useEffect, useState } from 'react';
import { ContentCopy } from '@mui/icons-material';
import { Check } from '@mui/icons-material';

const GroupSettings = () => {
    const [activeInvites, setActiveInvites] = useState([]);
    const [associatedUsers, setAssociatedUsers] = useState([]);
    const [copiedInvite, setCopiedInvite] = useState(null);
    const [editingUserId, setEditingUserId] = useState(null);
    const [editedRoles, setEditedRoles] = useState({});

    const loadInvites = () => {
        fetchGroupInvites(Cookies.get('session_key'))
            .then(data => {
                if (Array.isArray(data)) {
                    setActiveInvites(data);
                } else if (data && Array.isArray(data.invites)) {
                    setActiveInvites(data.invites);
                } else {
                    setActiveInvites([]);
                }
            })
            .catch(error => console.log(error));
    };

    const loadAssociatedUsers = () => {
        fetchAssociatedUsers(Cookies.get('session_key'))
            .then(data => {
                if (Array.isArray(data)) {
                    setAssociatedUsers(data);
                } else {
                    setAssociatedUsers([]);
                }
            })
            .catch(error => console.log(error));
    };

    useEffect(() => {
        loadInvites();
        loadAssociatedUsers();
    }, []);

    const returnNewInvite = () => {
        postNewInvite(Cookies.get('session_key'))
            .then(() => {
                loadInvites(); // Refresh invites after creating one
            })
            .catch(error => {
                console.log(error);
            });
    };

    const handleCopy = (invite) => {
        navigator.clipboard.writeText(invite)
            .then(() => {
                setCopiedInvite(invite);
                setTimeout(() => setCopiedInvite(null), 3000);
            })
            .catch((err) => {
                console.error('Failed to copy:', err);
            });
    };

    const handleRoleChange = (userId, newRole) => {
        setEditedRoles(prev => ({
            ...prev,
            [userId]: newRole,
        }));
    };

    const submitRoleChange = (userId) => {
        const newRole = editedRoles[userId];
        if (!newRole) return;

        const token = Cookies.get('session_key');
        const body = { permission: newRole };

        changeUserRole(token, body, userId)
            .then(() => {
                console.log(`Updated role for user ${userId} to ${newRole}`);
                setEditingUserId(null);
                loadAssociatedUsers(); // Refresh user list
            })
            .catch(error => {
                console.error('Failed to update role:', error.message);
            });
    };

    return (
        <div className='group-settings'>
            <h1>Group Settings</h1>
            <h2>Invite New Group Members</h2>
            <button onClick={returnNewInvite}>Invite New User</button>

            <div>
                {activeInvites.length === 0 ? (
                    <p>No active invites</p>
                ) : (
                    <ul>
                        {activeInvites.map((invite, index) => (
                            <li key={index} className="invite-item">
                                {invite}
                                {copiedInvite === invite ? (
                                    <div className='copy-message-container'>
                                        <Check />
                                        <span className="copy-message">Copied</span>
                                    </div>
                                ) : (
                                    <button
                                        onClick={() => handleCopy(invite)}
                                        className="copy-btn"
                                        aria-label="Copy invite"
                                    >
                                        <ContentCopy fontSize="small" />
                                    </button>
                                )}
                            </li>
                        ))}
                    </ul>
                )}
            </div>

            <h2>Associated Users</h2>
            {associatedUsers.length === 0 ? (
                <p>No associated users</p>
            ) : (
                <ul>
                    {associatedUsers.map((user, index) => (
                        <li key={index} className="associated-user-item">
                            <div className="user-info">
                                <strong>{user.name}</strong> – {user.email}
                                <span className="user-role">({user.type})</span>
                            </div>

                            {user.type !== 'master' && (
                                <div className="user-actions">
                                    {editingUserId === user.id ? (
                                        <div className="role-edit-controls">
                                            <select
                                                defaultValue={user.type}
                                                onChange={(e) => handleRoleChange(user.id, e.target.value)}
                                                className="role-dropdown"
                                            >
                                                <option value="user">User</option>
                                                <option value="operator">Operator</option>
                                            </select>
                                            <button
                                                onClick={() => submitRoleChange(user.id)}
                                                className="update-role-btn"
                                            >
                                                Update
                                            </button>
                                            <button
                                                onClick={() => setEditingUserId(null)}
                                                className="cancel-btn"
                                            >
                                                Cancel
                                            </button>
                                        </div>
                                    ) : (
                                        <button
                                            className="change-role-btn"
                                            onClick={() => setEditingUserId(user.id)}
                                        >
                                            Change Role
                                        </button>
                                    )}
                                </div>
                            )}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default GroupSettings;
